(function(){

  const header = document.querySelector('.homepage-header')
  const headerImage = document.querySelector('.homepage-header .image-container img')

  if (header && headerImage) {

    window.addEventListener('load', function() {
      const headerRect = header.getBoundingClientRect()

      let lastY = 0,
          lastX = 0,
          headerWidth = headerRect.width,
          headerHeight = headerRect.height,
          supportsVars = CSS.supports('color', 'var(--fake-var)'),
          lastTimestamp = 0,
          mouseOver = false;

      function update() {
        let percentageXFraction = (lastX / headerWidth) * 100
        let percentageX = Math.round(percentageXFraction) + '%'
        let percentageYFraction = (lastY / headerHeight) * 100
        let percentageY = Math.round(percentageYFraction) + '%'

        if (window.CSS && supportsVars) {
          header.style.setProperty('--pos-x', percentageX)
          header.style.setProperty('--pos-y', percentageY)
        } else {
          headerImage.style.transformOrigin = `${percentageX} ${percentageY} 0`
        }

        mouseOver = false
      }

      function onMouseMove(x, y) {
        lastY = y
        lastX = x
        requestTick()
      }

      function requestTick(x, y) {
        if(!mouseOver) {
          mouseOver = true
          requestAnimationFrame(update)
        }
      }

      window.addEventListener('mousemove', e => {
        // We need to rate limit this mousemove event because it is very expensive
        if(Date.now() - lastTimestamp > 25) {
          lastTimestamp = Date.now()
          onMouseMove(e.pageX, e.pageY)
        }
      }, {passive: true})
    })
  }


})();
